/* DNN-style homepage behaviours: hero slideshow (random order, 1s fade / 7s hold, like DNN's cycle2 banner).
   The "View More" / "Subscribe" expanders are plain details.piv-accordion, animated by piv-migrated-pages.js.
   Idempotent: several sections load this file. */
(function () {
  if (window.pivHomeInit) return;
  window.pivHomeInit = true;

  function initHero(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.pivh-hero__slide'));
    if (slides.length < 2) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = Math.floor(Math.random() * slides.length);
    slides.forEach(function (s) { s.style.transition = 'none'; s.classList.remove('is-active'); });
    slides[current].classList.add('is-active');
    slides[current].querySelector('img').loading = 'eager';
    void hero.offsetWidth;
    slides.forEach(function (s) { s.style.transition = ''; });
    if (reduce) return;
    var order = slides.map(function (_, i) { return i; }).sort(function () { return Math.random() - 0.5; });
    var pos = Math.max(0, order.indexOf(current));
    setInterval(function () {
      if (document.hidden) return;
      slides[order[pos]].classList.remove('is-active');
      pos = (pos + 1) % order.length;
      var next = slides[order[pos]];
      next.querySelector('img').loading = 'eager';
      next.classList.add('is-active');
    }, 7000);
  }

  // Smooth scroll for the hero's #anchor links only (CSS scroll-behavior on <html> breaks the theme's scroll-to-top button).
  function initJumpLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.pivh-card__links a[href^="#"], .pivh-down[href^="#"]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
    });
  }

  function ready() {
    document.querySelectorAll('.pivh-hero').forEach(initHero);
    initJumpLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
